import { render } from "./Index.vue?vue&type=template&id=717c1750"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/PurchaseOrdersRecv/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "717c1750"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('717c1750', __exports__)) {
    console.log('reload')
    api.reload('717c1750', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=717c1750", () => {
    console.log('re-render')
    api.rerender('717c1750', render)
  })

}


export default __exports__